import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import * as Colors from './colors';

export const NavText = styled(Text)`
  color: #fff;
`;


//Market Picker

export const MarketPicker = styled(Pressable)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 5px;
  background-color: #fff;
  margin-left: 10px;
`;

export const MarketLabelContainer = styled(View)`
  align-self: center;
  margin: 7.5px;

`;

export const MarketLabel = styled(Text)`
  font-size: 16px;
  font-weight: 600;
`;

export const DealerCountContainer = styled(View)`
  background-color: ${Colors.highlightBackground};
  padding: 5px;
  border-radius: 5px;
  margin: 7.5px;
`;

export const DealerCountLabel = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  color: ${Colors.highlightText};
`;

export const MarketOptionsContainer = styled(View)`
  position: absolute;
  margin-top: 5px;
  margin-left: 30px;
  width: 100%;
  background-color: ${Colors.highlightBackground};
  border-top-width: 1px;
`;

export const MarketOption = styled(Pressable)`
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: row;
  justify-content: space-between;
  border-width: 1px;
  border-top-width: 0px;
  ${props => props.selected ? `backgroundColor: ${Colors.highlightText};` : ''};
  &:hover {
    background-color: ${Colors.highlightText};
  }
`;

export const OptionText = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  ${props => props.selected ? `color: #fff;` : ''};
  &:hover {
    color: #fff;
  }
`;

export const PickerButton = styled(Pressable)`
  width: 25%;
  background-color: ${Colors.lightGrey};
  align-items: center;
  justify-content: center;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 10000;
  &:hover {
    cursor: pointer;
    background-color: lime;
  }
`;
